import React, { ChangeEventHandler, CSSProperties } from "react";

type Props = {
  className?: string;
  value?: string;
  name?: string;
  placeholder?: string;
  id?: string;
  handleChange?: ChangeEventHandler<HTMLInputElement>;
  required?: boolean;
  readOnly?: boolean;
  disabled?: boolean;
  onBlur?: any;
  type?: string;
  style?: CSSProperties;
};

const InputText: React.FC<Props> = ({
  className,
  value,
  name,
  placeholder,
  id,
  handleChange,
  required,
  readOnly,
  disabled,
  onBlur,
  type,
  style,
}) => {
  return (
    <input
      style={style}
      name={name}
      className={className}
      type={type}
      placeholder={placeholder}
      value={value}
      id={id}
      onChange={handleChange}
      required={required}
      readOnly={readOnly}
      disabled={disabled}
      onBlur={onBlur}
    />
  );
};

export { InputText };
